var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"map flex1 zjmap",attrs:{"id":"zjmap"}})
}
var staticRenderFns = []

export { render, staticRenderFns }